export const COMMENTS_BOX_WIDTH = 1500;
export const COMMENTS_BOX_GAP = 20;
export const ADD_COMMENT_ROW_HEIGHT = 80;
export const ADD_COMMENT_LABEL_WIDTH = 200;
